import chakraTokenToVar from '@/utils/chakraTokenToVar'

export default function NotFound({
  width = 265,
  ...props
}: {
  width?: number
  props?: React.ComponentProps<'svg'>
}): JSX.Element {
  const originalWidth = 265
  const originalHeight = 209
  const scale = width / originalWidth
  const viewBox = `0 0 ${originalWidth} ${originalHeight}`
  return (
    <svg
      width={originalWidth * scale}
      height={originalHeight * scale}
      viewBox={viewBox}
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <rect
          x={45.2002}
          y={5.76665}
          width={199.833}
          height={144.405}
          rx={6.19919}
          fill={chakraTokenToVar('bg.emphasized')}
          stroke={chakraTokenToVar('border.emphasized')}
          strokeWidth={3.64658}
        />
        <rect
          x={47.0234}
          y={22.9058}
          width={196.186}
          height={125.442}
          rx={4.3759}
          fill={chakraTokenToVar('bg.subtle')}
        />
        <circle
          cx={57.9628}
          cy={14.8832}
          r={4.01124}
          fill={chakraTokenToVar('gray.emphasized')}
          stroke={chakraTokenToVar('border.emphasized')}
          strokeWidth={0.729316}
        />
        <circle
          cx={70.3613}
          cy={14.8832}
          r={4.01124}
          fill={chakraTokenToVar('gray.emphasized')}
          stroke={chakraTokenToVar('border.emphasized')}
          strokeWidth={0.729316}
        />
        <circle
          cx={82.7602}
          cy={14.8832}
          r={4.01124}
          fill={chakraTokenToVar('gray.emphasized')}
          stroke={chakraTokenToVar('border.emphasized')}
          strokeWidth={0.729316}
        />
        <rect
          x={109.745}
          y={52.8076}
          width={8.7518}
          height={18.2329}
          rx={4.3759}
          fill={chakraTokenToVar('gray.emphasized')}
        />
        <rect
          x={171.737}
          y={52.8076}
          width={8.7518}
          height={18.2329}
          rx={4.3759}
          fill={chakraTokenToVar('gray.emphasized')}
        />
        <path
          d="M116.309 105.318c6.522-25.283 48.553-25.283 56.886 0"
          stroke={chakraTokenToVar('border.emphasized')}
          strokeWidth={8.7518}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x={81.9211}
          y={166.392}
          width={9.08231}
          height={36.0141}
          rx={4.54116}
          transform="rotate(-51.472 81.921 166.392)"
          fill={chakraTokenToVar('bg')}
          fillOpacity={0.6}
          stroke={chakraTokenToVar('gray.focusRing')}
          strokeWidth={7.88679}
        />
        <rect
          x={80.3232}
          y={166.231}
          width={10.5935}
          height={37.96}
          rx={5.29675}
          transform="rotate(-51.472 80.323 166.231)"
          fill={chakraTokenToVar('gray.emphasized')}
        />
        <circle
          cx={54.112}
          cy={136.923}
          r={39.8093}
          transform="rotate(-51.472 54.112 136.923)"
          stroke={chakraTokenToVar('gray.focusRing')}
          strokeWidth={11.0415}
        />
        <circle
          cx={54.0702}
          cy={136.676}
          r={37.9892}
          transform="rotate(-51.472 54.07 136.676)"
          fill={chakraTokenToVar('bg')}
          fillOpacity={0.6}
          stroke={chakraTokenToVar('border.emphasized')}
          strokeWidth={7.88679}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="white" d="M0 0H264.996V209H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
